import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Store, Phone, Mail, Menu, X } from 'lucide-react';
import { STORE_INFO } from '../../constants';
import type { NavItem } from '../../types';

const navItems: NavItem[] = [
  { label: 'Home', path: '/' },
  { label: 'Weekly Sales', path: '/weekly-sales' },
  { label: 'Announcements', path: '/announcements' },
  { label: 'Cafe Menu', path: '/cafe' },
  { label: 'Recipes', path: '/recipes' },
  { label: 'About Us', path: '/about' },
  { label: 'Contact', path: '/contact' }
];

export default function Navbar() {
  const [isMenuOpen, setMenuOpen] = useState(false);

  return (
    <header className="bg-[#568203] text-white">
      {/* Top Bar */}
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap items-center justify-between py-2 text-sm">
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-1">
              <Store size={16} />
              <span>{STORE_INFO.address}</span>
            </div>
            <div className="flex items-center gap-1">
              <Phone size={16} />
              <span>{STORE_INFO.phone}</span>
            </div>
            <div className="flex items-center gap-1">
              <Mail size={16} />
              <span>{STORE_INFO.email}</span>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <span>Open {STORE_INFO.daysOpen}</span>
            <span>{STORE_INFO.hours}</span>
          </div>
        </div>
      </div>
      {/* Navbar */}
      <nav className="bg-white shadow-md">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between py-4">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-2">
              <img src="/logo.svg" alt="Basmati Grocers" className="h-12 w-auto" />
              <span className="text-2xl font-bold text-[#568203]">{STORE_INFO.name}</span>
            </Link>
            {/* Hamburger Menu for Mobile */}
            <button
              className="lg:hidden block text-gray-600"
              onClick={() => setMenuOpen(!isMenuOpen)}
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
            {/* Desktop Menu */}
            <div className="hidden lg:flex gap-6">
              {navItems.map((item) => (
                <Link
                  key={item.label}
                  to={item.path}
                  className="text-gray-600 hover:text-[#568203] transition-colors"
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="bg-white lg:hidden">
            <nav className="flex flex-col items-start px-4 py-4 space-y-4">
              {navItems.map((item) => (
                <Link
                  key={item.label}
                  to={item.path}
                  className="text-gray-800 hover:text-[#568203] text-lg font-medium transition-colors"
                  onClick={() => setMenuOpen(false)}
                >
                  {item.label}
                </Link>
              ))}
            </nav>
          </div>
        )}
      </nav>
    </header>
  );
}